export const DEFAULT_STAGE_KEY = 'defaultStage'
export const CURTAINS_KEY = 'curtains'
export const LOGUE_KEY = 'logue'

export const NOHO_HOUSES_KEY = 'nohoHouses'
export const NOHO_HOUSES_NIGHT_KEY = 'nohoHousesNight'
export const NOHO_SCHOOL_KEY = 'nohoSchool'
export const BATHROOM_KEY = 'bathroom'
export const BATHROOM_PAST_KEY = 'bathroomPast'

export const FREEWAY_KEY = 'freeway'
export const FREEWAY_NIGHT_KEY = 'freewayNight'
export const PORCH_KEY = 'porch'
export const CHANGELING_MAGIC_KEY = 'changelingMagic'

export const PUPPET_SHOW_KEY = 'puppetShow'
export const SCHOOLBUS_KEY = 'schoolbus'
export const TETHERBALL_COURT_KEY = 'tetherballCourt'

export const TAIWAN_ROOM_KEY = 'taiwanRoom'
export const TAIWAN_STAIRS_KEY = 'taiwanStairs'
export const TAIWAN_GATE_KEY = 'taiwanGate'
export const RICKSHAW_KEY = 'rickshaw'
export const SHORE_KEY = 'shore'
export const BUOY_KEY = 'buoy'
export const OCEAN_DEPTHS_KEY = 'oceanDepths'
export const OCEAN_FLOOR_KEY = 'oceanFloor'

export const BEDROOM_KEY = 'bedroom'
export const BEDROOM_DIM_KEY = 'bedroomDim'
export const CAPTAIN_BED_KEY = 'captainBed'
export const BEDROOM_EVENING_KEY = 'bedroomEvening'
export const BEDROOM_STOOL_KEY = 'bedroomStool'
export const BEDROOM_STOOL_NIGHT_KEY = 'bedroomStoolNight'
export const BEDROOM_DARK_KEY = 'bedroomDark'
export const BEDROOM_MAGIC_KEY = 'bedroomMagic'
export const BEDROOM_FUTURE_KEY = 'bedroomFuture'

export const VAN_NUYS_LOCKERS_KEY = 'vanNuysLockers'
export const VAN_NUYS_QUAD_KEY = 'vanNuysQuad'
export const VAN_NUYS_HALLWAY_KEY = 'vanNuysHallway'

export const CATHOLIC_CHURCH_KEY = 'catholicChurch'
export const BERKELEY_BANCROFT_KEY = 'berkeleyBancroft'
export const BERKELEY_CAMPANILE_KEY = 'berkeleyCampanile'

export const CINEMA_KEY = 'cinema'
export const CINEMA_STREET_KEY = 'cinemaStreet'

export const BASEMENT_KEY = 'basement'
export const BASEMENT_COUCH_KEY = 'basementCouch'
export const BASEMENT_BED_DARK_KEY = 'basementBedDark'
export const BASEMENT_BED_MAGIC_KEY = 'basementBedMagic'

export const MUSEUM_KEY = 'museum'
export const BACKSTAGE_KEY = 'backstage'
export const GO_KARTS_KEY = 'goKarts'

export const DISHROOM_KEY = 'dishroom'
export const WAITING_ROOM_KEY = 'waitingRoom'

export const CLUB_FRONT_KEY = 'clubFront'
export const CLUB_SIDE_CROWD_KEY = 'clubSideCrowd'
export const CLUB_SIDE_CROWD_DARK_KEY = 'clubSideCrowdDark'
export const CLUB_SIDE_STAGE_KEY = 'clubSideStage'
export const CLUB_LOADING_KEY = 'clubLoading'
export const CLUB_FAR_DARK_KEY = 'clubFarDark'

export const BENNETT_BED_KEY = 'bennettBed'
export const BENNETT_BED_DARK_KEY = 'bennettBedDark'
export const BENNETT_COUCH_KEY = 'bennettCouch'
export const BENNETT_COUCH_KEYBOARD_KEY = 'bennettCouchKeyboard'
export const BENNETT_COUCH_THOUGHT_KEY = 'bennettCouchThought'
export const COURTYARD_KEY = 'courtyard'
export const BENNETT_GATE_KEY = 'bennettGate'

export const LIZ_BED_KEY = 'lizBed'
export const LIZ_BED_LOVE_KEY = 'lizBedLove'
export const LIZ_BED_DARK_KEY = 'lizBedDark'
export const LIZ_BED_DARK_EXTRA_KEY = 'lizBedDarkExtra'
export const LIZ_BED_PHONE_KEY = 'lizBedOpenPhone'

export const LIZ_COUCH_KEY = 'lizCouch'
export const LIZ_COUCH_EVENING_KEY = 'lizCouchEvening'
export const LIZ_COUCH_NIGHT_KEY = 'lizCouchNight'
export const LIZ_COUCH_SEAT_KEY = 'lizCouchSeat'
export const LIZ_COUCH_DARK_KEY = 'lizCouchDark'
export const LIZ_COUCH_FUTURE_KEY = 'lizCouchFuture'
export const LIZ_GATE_KEY = 'lizGate'
export const LIZ_GATE_STREET_KEY = 'lizGateStreet'

export const ROYCE_HALL_KEY = 'royceHall'
export const WALGREENS_KEY = 'walgreens'
export const STEAM_TUNNEL_KEY = 'steamTunnel'
export const CEMETERY_KEY = 'cemetery'
export const STATION_WAGON_KEY = 'stationWagon'
export const ATTIC_KEY = 'attic'

export const OAKLAND_HOUSES_KEY = 'oaklandHouses'
export const OAKLAND_VOLKSWAGEN_KEY = 'oaklandVolkswagen'
export const OAKLAND_COUCH_THOUGHT_KEY = 'oaklandCouchThought'
export const OAKLAND_RESIDENTIAL_KEY = 'oaklandResidential'
export const OAKLAND_COMMERCIAL_KEY = 'oaklandCommercial'
export const OAKLAND_PUBLIC_KEY = 'oaklandPublic'

export const SNOWGLOBES_PAST_KEY = 'snowglobesPast'
export const SNOWGLOBES_PRESENT_KEY = 'snowglobesPresent'
export const SNOWGLOBES_FUTURE_KEY = 'snowglobesFuture'

export const EL_CERRITO_EVENING_KEY = 'elCerritoEvening'
export const EL_CERRITO_CAR_KEY = 'elCerritoCar'
export const EL_CERRITO_DEATHBED_KEY = 'elCerritoDeathbed'
export const EL_CERRITO_TENNIS_KEY = 'elCerritoTennis'

export const ALLEY_KEY = 'alley'

export const EL_TORITO_KEY = 'elTorito'
export const PAMPAS_KEY = 'pampas'
export const WEDDING_KEY = 'wedding'
export const CLIFF_KEY = 'cliff'
export const CLIFF_DEATHBED_KEY = 'cliffDeathbed'
